module.exports = __webpack_public_path__ + "img/red.1a2ae029.png";